import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class LoginModalService {
  private openModalSubject = new Subject<void>();
  private pendingAction: (() => void) | null = null;

  constructor(private loginService: LoginService) {}

  /** POST auth/email-login — called from header email/password form */
  emailLogin(email: string, password: string): Observable<any> {
    return this.loginService.emailLogin(email, password);
  }

  /** Emits when login modal should open. Header subscribes to this. */
  openModal$ = this.openModalSubject.asObservable();

  /** Emits true when modal is open, false when closed. Carousel/sliders can pause when true. */
  readonly isModalOpen$ = new BehaviorSubject<boolean>(false);

  /**
   * Request to open login modal. Optionally pass a callback to run after successful login.
   */
  requestLogin(pendingAction?: () => void): void {
    this.pendingAction = pendingAction ?? null;
    this.openModalSubject.next();
  }

  /** Call when modal opens (header) */
  setModalOpen(open: boolean): void {
    this.isModalOpen$.next(open);
  }

  /** Get and clear the pending action (called by header after successful login) */
  consumePendingAction(): (() => void) | null {
    const action = this.pendingAction;
    this.pendingAction = null;
    return action;
  }
}
